<template>
<div class="coupon">
    <router-view></router-view>
</div>
</template>

<script>
export default {
    name: 'coupon',
    data() {
        return {}
    },
    mounted() {
    },
    methods: {},
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.coupon {
}
</style>
